import { useSelector } from 'react-redux';
import Modal from 'ui/components/atoms/Modal';
import { ITermAndConditionsContent } from '../TermAndConditions';
import { IRootState } from '../../../store';
import { useEffect, useState } from 'react';
import { contentService } from '../../../services';
import { TNC_TYPE } from '../../../constants/tncType';
import { ModalMobileNativeScroll, TermsModalContentServices } from '../../atoms';

interface IModalTermsRegisterProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  termsCondition?: ITermAndConditionsContent;
  showAgreeButton?: boolean;
}

const ModalTermsServices = ({
  visible = false,
  setVisible = () => {},
  termsCondition: _termsCondition,
  showAgreeButton,
}: IModalTermsRegisterProps) => {
  const { isMobileScreen } = useSelector((state: IRootState) => state.page);
  const [termsCondition, setTermCondition] = useState<ITermAndConditionsContent>({});

  useEffect(() => {
    if (!_termsCondition) {
      contentService
        .getTermCondition({
          type: TNC_TYPE.registerPage,
        })
        .then((res) => {
          setTermCondition(res?.data || {});
        });
    }
  }, []);

  return isMobileScreen ? (
    <ModalMobileNativeScroll
      title="Syarat & Ketentuan"
      height="h-full"
      visible={visible}
      onClose={() => setVisible(false)}
      bodyClassName="py-2 md:py-4 overflow-y-auto max-h-full"
    >
      <TermsModalContentServices
        content={_termsCondition || termsCondition}
        setShowTermsModalTnc={setVisible}
        showAgreeButton={showAgreeButton}
      />
    </ModalMobileNativeScroll>
  ) : (
    <Modal
      header={true}
      title="Syarat & Ketentuan"
      className="w-[622px]"
      headerTitleClassName="text-xl !font-bold text-reliableBlack"
      bodyClassName="max-h-[80vh] px-6 py-2"
      visible={visible}
      onClose={() => setVisible(false)}
      as="p"
    >
      <TermsModalContentServices
        content={_termsCondition || termsCondition}
        setShowTermsModalTnc={setVisible}
        showAgreeButton={showAgreeButton}
      />
    </Modal>
  );
};

export default ModalTermsServices;
